import { useTranslation } from 'react-i18next';
import React, { useEffect } from "react";
import { Table } from "antd";
import { useAllocModel } from "../allocModel";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
import useGlobalModel from "@/erp_subpackage/model/globalModel";

export function DataTable() {
    const { t } = useTranslation();
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useAllocModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { setMaterialInfo } = useGlobalModel(() => []);

    useEffect(() => {
        loadData();
    }, [])

    const columns = [
        {
            title: t(`stock.view.DataTable.序号`),
            width: 60,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: t(`stock.view.DataTable.商品编号`),
            fixed: "left",
            width: 160,
            dataIndex: 'materialCode',
            // render: (text) => <YhTooltip text={text} />,
            render: (text, record) => <YhTooltip text={text} onClick={() => setMaterialInfo(true, { materialCode: text, materialName: record.materialName })} />,
        },
        {
            title: t(`stock.view.DataTable.商品名称`),
            fixed: "left",
            width: 160,
            dataIndex: 'materialName',
            render: (text) => <YhTooltip text={text} />,
        },
        {
            title: t(`stock.view.DataTable.调拨数量`),
            width: 100,
            dataIndex: 'num',
        }, {
            title: t(`stock.view.DataTable.调拨单号`),
            width: 220,
            dataIndex: 'transferCode',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`stock.view.DataTable.调出机构`),
            width: 160,
            dataIndex: 'outShopName',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`stock.view.DataTable.已出库数量`),
            width: 100,
            dataIndex: 'stockIoNum',
        }, {
            title: t(`stock.view.DataTable.出库状态`),
            width: 100,
            dataIndex: 'stockOutStatus',
            render: text => getTreeNodeName(text)
        }, {
            title: t(`stock.view.DataTable.出库时间`),
            width: 180,
            dataIndex: 'transferOutTime',
        }, {
            title: t(`stock.view.DataTable.调入机构`),
            width: 160,
            dataIndex: 'shopName',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`stock.view.DataTable.已入库数量`),
            width: 100,
            dataIndex: 'inStockIoNum',
        }, {
            title: t(`stock.view.DataTable.入库状态`),
            width: 120,
            dataIndex: 'stockInStatus',
            render: text => getTreeNodeName(text)
        }, {
            title: t(`stock.view.DataTable.入库时间`),
            width: 180,
            dataIndex: 'transferInTime',
        }, {
            title: t(`stock.view.DataTable.备注`),
            width: 160,
            dataIndex: 'note',
        }
    ];

    //点击行选高亮
    const onRow = (id) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `${t(`stock.view.DataTable.共`)}${pgCfg.total}${t(`stock.view.DataTable.条`)}`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={dataSource.length ? { x: 'max-content', y: "calc(100vh - 430px)" } : { x: 'max-content' }}
        />
    )
}